module.exports = __webpack_public_path__ + "static/media/trash.6a6f191e.svg";